<template>
  <div class="deal-properties-container">
    <div class="pdp-deal-terms-title d-flex">
      <h5 class="mb-3">
        {{ title }}
      </h5>
    </div>
    <span
      v-if="subTitle"
      class="subheader mb-4"
    >
      {{ subTitle }}
    </span>
    <ul class="list-unstyled">
      <li
        v-for="property in properties"
        :key="`${idPrefix}-${property.id}`"
        class="mb-3 d-flex"
      >
        <div class="d-flex checkbox-container">
          <img
            class="featureCheck mr-2 my-auto"
            alt="Check"
            src="@legacy/static/images/discussions/as-check.svg"
            width="16px"
            height="11.9px"
          >
        </div>
        <!-- eslint-disable-next-line vue/no-v-html-->
        <span v-html="property.text" />
      </li>
    </ul>
    <slot name="afterPropertyList" />
  </div>
</template>

<script>
export default {
  props: {
    /* Note: we used to support collapsible properties,
      commit assoc. with this comment removes this functionality */
    idPrefix: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      default: null,
    },
    // jw: array of objects in structure {'id', 'text'}
    properties: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .pdp-deal-terms-title {
    font-size: 20px;
    line-height: 30px;
  }

  .checkbox-container {
    height: 24px; // jl: == .deal-properties-container > ul > li line-height
  }

  .deal-properties-container {
    ul {
      padding: 0;

      li {
        list-style-type: none;
        position: relative;
        line-height: 24px;
        font-size: 1rem;

        // jl: leaving this code below for now. I believe it might be advantageous performance-wise
        // for us to take a similar approach instead of using the checkmark <img>

        // &::before {
        //   content: ' ';
        //   display: block;
        //   width: 7px;
        //   height: 14px;
        //   border: solid #07c03b;
        //   border-width: 0 2px 2px 0;
        //   position: absolute;
        //   left: 4px;
        //   top: 2px;
        //   transform: rotate(45deg);
        // }
      }
    }

    h5 {
      font-weight: 600;
      color: #000;
      font-size: 20px;
      line-height: 30px;
    }
  }

  .subheader {
    color: #000;
    font-size: 16px;
  }
</style>
